module.exports = __webpack_public_path__ + "img/01-03_Thinking globally.6228908e.svg";